import { type ReactNode } from 'react';

import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

const wrapperStyles = xcss({
	position: 'relative',
	minHeight: '100vh',
	width: '100%',
	isolation: 'isolate',
});

// Fixed to the viewport so the blobs span the full screen width regardless
// of any narrower parent container.
const backgroundLayerStyles = xcss({
	position: 'fixed',
	insetBlockStart: '0',
	insetInlineStart: '0',
	width: '100vw',
	height: '100vh',
	overflow: 'hidden',
	pointerEvents: 'none',
});

// Positioned so it paints above the fixed background layer (later-in-DOM
// positioned element wins painting order within the same stacking context).
const contentLayerStyles = xcss({
	position: 'relative',
});

const gradientBlobStyle = {
	position: 'absolute',
	width: '54vw',
	height: '54vw',
	borderRadius: '50%',
	filter: 'blur(12.5rem)',
	pointerEvents: 'none',
} as const;

export const GradientBackground = ({ children }: { children: ReactNode }) => {
	return (
		<Box xcss={wrapperStyles} testId="gradient-background">
			<Box xcss={backgroundLayerStyles}>
				<div
					style={{
						...gradientBlobStyle,
						top: '-40vh',
						left: '-36vw',
						// Hex fallback covers the case where the Atlassian
						// tokens theme isn't loaded on this page (the token
						// CSS var would otherwise be undefined).
						backgroundColor: token('color.background.accent.blue.subtler', '#CFE1FD'),
					}}
				/>
				<div
					style={{
						...gradientBlobStyle,
						bottom: '-55vh',
						right: '-28vw',
						backgroundColor: token('color.background.accent.blue.subtlest', '#E9F2FE'),
					}}
				/>
			</Box>
			<Box xcss={contentLayerStyles}>{children}</Box>
		</Box>
	);
};
